import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextInput,
  Form,
  FormGroup,
  InlineNotification,
} from "@carbon/react";

import { callApi } from "../../services/apiService";
import { useUser } from "../../context/UserContext";


function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useUser(); // get login function from context


  // const handleSubmit = (e) => {
  //   e.preventDefault();

    
  //   if (username === "admin" && password === "admin") {
  //     navigate("/dashboard"); 
  //   } else {
  //     setError("Invalid username or password");
  //   }
  // };

// In Login.jsx, inside handleSubmit


const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const response = await callApi("POST", "/auth/login", { username, password });
    login(response.data); // set user info in context
    navigate("/dashboard", { replace: true });
  } catch (err) {
    console.error("Login error:", err);
    setError("Invalid username or password");
  }
};

  return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#f4f4f4",
        }}
      >
        <Form
          onSubmit={handleSubmit}
          style={{
            background: "white",
            padding: "2rem",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            width: "320px",
          }}
        >
          <h3 style={{ marginBottom: "1rem", textAlign: "center" }}>Login</h3>

          <FormGroup legendText="">
            <TextInput
              id="username"
              labelText="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </FormGroup>

          <FormGroup legendText="">
            <TextInput
              id="password"
              labelText="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              type="password"
            />
          </FormGroup>

          {error && (
            <InlineNotification
              kind="error"
              title="Login Failed"
              subtitle={error}
              onCloseButtonClick={() => setError("")}
              style={{ marginBottom: "1rem" }}
            />
          )}

          <Button type="submit" style={{ width: "100%" }}>
            Sign In
          </Button>
        </Form>
      </div>
  );
}

export default Login;